import React, {useEffect, useState} from "react";
import {useMakePageRequest} from "./RequestHooks";
import {useChangeContext} from "./RouteHooks";
import {selectParentContext} from "../Redux/Selectors/contextSelectors";
import {useSelector} from "react-redux";
import * as PropTypes from "prop-types";
import {ConfirmationDialog} from "../Components/Common/ConfirmationDialog";

export const usePrimeCache = (services) => {
    const [loaded, setLoaded] = useState(false);
    
    if(!(services instanceof Array)) {
        services = [services];
    }

    services = services.filter(service => {
        if (!service?.PrimeCache) {
            console.log('Warning: ' + service?.ModelName + 'Service does not support PrimeCache.');
            return false;
        }
        return true;
    });

    useEffect(() => {
        Promise.allSettled(services.map(service => service.PrimeCache()))
            .then(result => {
                setLoaded(true);
            });
    }, []);
    
    return loaded;
};

export const useDeleteModelConfirmationDialog = () => {
    const [visible, setVisible] = useState(false);

    const DeleteModelConfirmationDialog = props => {

        const {service, modelId} = props;
        
        const makePageRequest = useMakePageRequest();
        const changeContext = useChangeContext();
        const parentContext = useSelector(state => selectParentContext(state));
        
        const onClose = () => {
            setVisible(false);
        }
        
        const onConfirm = () => {
            makePageRequest(
                () => service.Delete(modelId),
                (x) => { changeContext(parentContext); }
            );
        };
        
        return <ConfirmationDialog
            Title="Confirmation"
            Body={`Are you sure you want to delete this ${service.ModelName}?`}
            Display={visible}
            OnClose={props.onClose ?? onClose}
            OnConfirm={props.onConfirm ?? onConfirm}
        />;
    };

    return [DeleteModelConfirmationDialog, setVisible];
};
